import {ADYEN, IFOOD} from '../../constants/psrs';

export const generateiFoodPsr = (response) => {
  if (!Array.isArray(response)) {
    return response || [];
  }

  const haveAdyen = response.filter((item) => item.id === ADYEN);

  if (haveAdyen.length) {
    response.push({...haveAdyen[0], name: 'iFood', id: IFOOD});
  }

  return response;
};

export const checkIdiFood = (id) => {
  return id === IFOOD ? ADYEN : id;
};

export const prepareAdyebAndIFoodToSend = (newPsrList) => {
  let haveDuplicateAdyen = newPsrList.filter((item) => item.psr === ADYEN);

  if (haveDuplicateAdyen.length === 2) {
    let newPsrListWhitoutAdyen = newPsrList.filter(
      (item) => item.psr !== ADYEN
    );

    return newPsrListWhitoutAdyen.concat(haveDuplicateAdyen[0]);
  }

  return newPsrList;
};
